import {
    ProfileCreationFunnelMode,
    ProfileCreationStep,
    ProfileCreationStepGroup,
    RoutesConfig,
} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import {RouteLocationNormalized, RouteRecordRaw} from 'vue-router';
import {Features} from 'vue3-starter/src/typescript/features';

const MALT_STRATEGY_SEARCH_PARAM = 'maltStrategy';

const ProfileCreationRouterHelper = {
    hasNoPreviousRoute: (from: RouteLocationNormalized): boolean => {
        return !from.name;
    },
    getFirstRouteOfGroup(routesConfig: RoutesConfig, stepGroup: ProfileCreationStepGroup): RouteRecordRaw {
        const firstRouteName = stepGroup === ProfileCreationStepGroup.SIGNUP ? routesConfig.creationFirstStep : routesConfig.completionFirstStep;
        const filteredRoutes = routesConfig.routes.filter((route) => route.name === firstRouteName && route.meta && route.meta.previousStep === null);

        if (filteredRoutes.length !== 1) {
            throw new Error(`getFirstRouteOfGroup must only contain one first route for group ${stepGroup}. Got ${filteredRoutes.length} route(s).`);
        }

        return filteredRoutes[0];
    },
    isFeatureFlagFreelancerConvergenceSignupActivated: (features: Features): boolean => {
        return features.freelancerConvergenceSignup === true;
    },
    isFunnelModeStrategyActivated: (searchParams: URLSearchParams): boolean => {
        return searchParams.get(MALT_STRATEGY_SEARCH_PARAM)?.toLowerCase() === 'true';
    },
    isGoingToAStepOfGroup: (stepGroup: ProfileCreationStepGroup, to: RouteLocationNormalized): boolean => {
        return to?.meta?.stepGroup === stepGroup;
    },
    isGoingToFirstStepOfGroup: (routesConfig: RoutesConfig, stepGroup: ProfileCreationStepGroup, to: RouteLocationNormalized): boolean => {
        switch (stepGroup) {
            case ProfileCreationStepGroup.SIGNUP:
                return to?.path.toLowerCase() === '/signup/headline';
            case ProfileCreationStepGroup.COMPLETION:
                return to?.path.toLowerCase() === ProfileCreationRouterHelper.getFirstRouteOfGroup(routesConfig, stepGroup).path;
        }
    },
    needsRedirectionToFirstStepOfGroup: (
        routesConfig: RoutesConfig,
        stepGroup: ProfileCreationStepGroup,
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
    ): boolean => {
        return (
            ProfileCreationRouterHelper.hasNoPreviousRoute(from) &&
            ProfileCreationRouterHelper.isGoingToAStepOfGroup(stepGroup, to) &&
            !ProfileCreationRouterHelper.isGoingToFirstStepOfGroup(routesConfig, stepGroup, to)
        );
    },
    routeIsAnAlias: (to: RouteLocationNormalized, aliases: string[]): boolean => {
        return to.path ? aliases.includes(to.path) : false;
    },
    buildRouteFromStep: (
        profileCreationStep: ProfileCreationStep,
        funnelMode: ProfileCreationFunnelMode = ProfileCreationFunnelMode.FREELANCER,
    ): RouteRecordRaw => {
        return {
            path: profileCreationStep.route,
            name: profileCreationStep.name,
            component: profileCreationStep.component,
            meta: {
                funnelMode,
                stepGroup: profileCreationStep.group,
                stepNumber: profileCreationStep.stepNumber,
                stepCount: profileCreationStep.stepCount,
                progressPercentage: profileCreationStep.stepPercentage,
                previousStep: profileCreationStep.previousStepName,
                nextStep: profileCreationStep.nextStepName,
            },
        };
    },
};

export default ProfileCreationRouterHelper;
